import { createContext, FunctionComponent, useContext, useMemo } from "react";
import type { IProps, ISteppedModalStepScope } from "./stepped-modal-step-scope.types";

/**
 * Defaults to active so a step rendered outside a SteppedModal.Formik (e.g. in isolation in a test or
 * story) still shows its children, and registration is a no-op.
 */
const SteppedModalStepScopeContext = createContext<ISteppedModalStepScope>({
    isActive: true,
    index: 0,
    registerValidation: () => {},
});

/**
 * Tells one step which index it occupies, whether it is the active step, and how to register its
 * validation with the owning modal. The modal renders one of these per step.
 */
export const SteppedModalStepScope: FunctionComponent<IProps> = ({
    index,
    isActive,
    registerValidation,
    children,
}) => {
    const value = useMemo(() => ({ index, isActive, registerValidation }), [index, isActive, registerValidation]);
    return <SteppedModalStepScopeContext.Provider value={value}>{children}</SteppedModalStepScopeContext.Provider>;
};

export const useStepScope = (): ISteppedModalStepScope => useContext(SteppedModalStepScopeContext);
